import * as React from 'react'
import { connect } from 'react-redux'
import { getVoices } from '../Voices.actions'
import { VoicesListComponent } from './VoiceList'
import { IVoicesState } from '../Voices.reducer'
import { get } from 'lodash'
import { replace } from 'react-router-redux'
import { showVoiceCreateModal } from '../VoiceCreateModal'

export interface IVoiceListContainerProps {
  page: number
}

const stateToProps = ({ voices }: { voices: IVoicesState }, { page }: IVoiceListContainerProps) => {
  const cacheKey = `${page}`
  return {
    cacheKey,
    totalPages: get(voices, ['list', cacheKey, 'data', 'totalPages'], 1),
    loading: get(voices, ['list', cacheKey, 'loading'], true),
    results: get(voices, ['list', cacheKey, 'data', 'results'], []).map(
      voiceId => voices.byId[voiceId].data
    ),
  }
}

export const dispatchToProps = {
  getVoices,
  replace,
  showVoiceCreateModal,
}

export const VoiceList = connect(stateToProps, dispatchToProps)(VoicesListComponent) as React.SFC<
  IVoiceListContainerProps
>



// WEBPACK FOOTER //
// src/features/Voices/VoiceList/VoiceList.container.ts